import { Cascata } from './Cascata'
import { Faceta } from './Faceta'
import { Inline } from './Inline'
import { NavegarFuncionario } from './NavegarFuncionario'
import { Root } from './Root'
import { Trigger } from './Trigger'

type FacetaProps = {
    multiple?: boolean
    /** lista as opções de todas as empresas do cliente, ignorando o escopo */
    listAll?: boolean
}

/**
 * Controle único de escopo: empresa → [centros de custo ∥ locais] → funcionário.
 *
 * ```tsx
 * const [escopo, setEscopo] = useEscopoFuncionario()
 *
 * <EscopoFuncionario.Root value={escopo} onChange={setEscopo}>
 *     <EscopoFuncionario.Cascata>
 *         <EscopoFuncionario.Trigger />
 *         <EscopoFuncionario.Empresa />
 *         <EscopoFuncionario.CentrosCusto multiple />
 *         <EscopoFuncionario.Locais multiple />
 *     </EscopoFuncionario.Cascata>
 * </EscopoFuncionario.Root>
 * ```
 */
export const EscopoFuncionario = {
    Root,
    Trigger,
    Cascata,
    Inline,
    NavegarFuncionario,
    Empresa: (props: FacetaProps) => <Faceta id="empresas" {...props} />,
    CentrosCusto: (props: FacetaProps) => (
        <Faceta id="centrosCusto" {...props} />
    ),
    Locais: (props: FacetaProps) => <Faceta id="locais" {...props} />,
    Funcionarios: (props: FacetaProps) => (
        <Faceta id="funcionarios" {...props} />
    ),
}

export { filtrarNoEscopo, queryParamsDoEscopo, um, varios } from './escopo'
export type { Escopo, FacetaId } from './escopo'
export type { TriggerProps } from './Trigger'
export { useEscopoFuncionario } from './useEscopoFuncionario'
